module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "top-nav"
  }, [_c('router-link', {
    staticClass: "order vux-1px-b flex",
    attrs: {
      "to": "/orderList/all",
      "tag": "div"
    }
  }, [_c('span', [_vm._v("我的订单")]), _vm._v(" "), _c('span', {
    attrs: {
      "calss": "r"
    }
  }, [_vm._v("查看所有订单 "), _c('i', {
    staticClass: "iconfont icon-youjiantou-copy"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex top-nav-btm"
  }, [_c('router-link', {
    staticClass: "flex-1 vux-1px-r",
    attrs: {
      "to": "/orderList/unpaid",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daifukuan"
  }), _vm._v(" "), _c('span', [_vm._v("待付款")]), _vm._v(" "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderNum.unpaid),
      expression: "orderNum.unpaid"
    }]
  }, [_vm._v(_vm._s(_vm.orderNum.unpaid))])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex-1 vux-1px-r",
    attrs: {
      "to": "/orderList/paid",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daifahuo"
  }), _vm._v(" "), _c('span', [_vm._v("待发货")]), _vm._v(" "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderNum.paid),
      expression: "orderNum.paid"
    }]
  }, [_vm._v(_vm._s(_vm.orderNum.paid))])]), _vm._v(" "), _c('router-link', {
    staticClass: "flex-1 vux-1px-r",
    attrs: {
      "to": "/orderList/shipped",
      "tag": "div"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-daishouhuo-copy"
  }), _vm._v(" "), _c('span', [_vm._v("已发货")]), _vm._v(" "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderNum.shipped),
      expression: "orderNum.shipped"
    }]
  }, [_vm._v(_vm._s(_vm.orderNum.shipped))])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db94b060"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/TopNav.vue
// module id = 620
// module chunks = 0